<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    @if (form) {
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="grid-form-container">
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_fieldLabelIncidentId' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="incidentId"
                               name="incidentId"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_field#related' | translate }}</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="relatedOrganizations"
                               name="relatedOrganizations"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_column#governmentOrganization' | translate }}</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="governmentOrganization"
                               name="governmentOrganization"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_column#authorOrganization' | translate }}</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="createdByOrganization"
                               name="createdByOrganization"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_column#incidentStatus' | translate }}</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="status"
                               name="status"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_field#resolution' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="resolution"
                               name="resolution"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_resolution#createdDate' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               readonly
                               formControlName="createdDate"
                               name="createdDate"/>
                    </mat-form-field>
                </div>
            </div>
        </form>
    }
</div>
